export default {"src":"/_next/static/media/0x4691937a7508860f876c9c0a2a617e7d9e945d4b.cac1eece.svg","height":240,"width":240,"blurWidth":0,"blurHeight":0};